<i18n lang="yaml" locale="en">
  add to box: Add to box
</i18n>

<i18n lang="yaml" locale="de">
  add to box: Zur Box hinzufügen
</i18n>

<template>
  <div>
    <dropzone
      :target="$parent"
      @drop="onDrop"
      :validation-fn="validateDrag"
    >
      {{ $t('add to box') }}
    </dropzone>
    <placeholder
      v-if="this.$store.getters.numChildren === 0"
      message="Dateien hier ablegen."
    />
    <sortable
      v-else
      handle=".move-handle"
      @sortstart="onSortstart"
      @sort="onSort"
      @sortend="onSortend"
    >
      <slot />
    </sortable>
  </div>
</template>

<script>
import Placeholder from '@/components/editor/Placeholder'
import Dropzone from '@/components/editor/Dropzone'
import Sortable from '@/components/utils/Sortable'

export default {
  name: 'FilesEditor',
  inheritAttrs: false,
  components: {
    Placeholder,
    Dropzone,
    Sortable
  },
  data () {
    return {
      dragItem: undefined
    }
  },
  methods: {
    onSortstart ({ dragItem }) {
      this.dragItem = dragItem.split('-')[0]
    },
    onSort ({ overItem }) {
      overItem = overItem.split('-')[0]
      if (this.dragItem !== undefined && this.dragItem !== overItem) {
        const oldIndex = this.$store.getters.modulesByPath[this.dragItem].getters.index
        const newIndex = this.$store.getters.modulesByPath[overItem].getters.index
        this.$store.getters.children[oldIndex].dispatch('move', {
          movement: newIndex - oldIndex
        })
      }
    },
    onSortend () {
      this.dragItem = undefined
    },
    validateDrag (event) {
      if (event.dataTransfer.types.includes('assets')) {
        const paths = Object.keys(this.$root.$store.getters.selectedAssets)
        const accepted = paths.filter(path => {
          const module = this.$store.getters.modulesByPath[path]
          // only allow acceptedFileTypes
          return this.acceptedFileTypes.includes(module.getters.type.name)
        })
        return accepted.length > 0
      }
    },
    onDrop (event) {
      // dropped assets from asset-editor
      if (event.dataTransfer.getData('assets')) {
        const assets = Object.keys(this.$root.$store.getters.selectedAssets).map(path => this.$store.getters.modulesByPath[path])
        this.parseAssets(assets)
      }
    },
    parseAssets (assets) {
      for (const asset of assets) {
        if (asset.getters.type.name !== 'folder') {
          if (this.acceptedFileTypes.includes(asset.getters.type.name)) {
            this.$store.dispatch('cloneFrom', {
              path: asset.getters.path
            })
          }
        } else {
          this.parseAssets(asset.getters.children)
        }
      }
      this.$root.$store.dispatch('deselectAllAssets')
    }
  },
  computed: {
    acceptedFileTypes () {
      return ['image', 'video', 'pdf', 'otherFile', 'audio', 'folder']
    }
  }
}
</script>
